import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

export function websiteNewsletter(email) {
  const data = { email_address: email, webpage_id: "RiderOnboarding" };
  const functions = getFunctions(getApp(), "australia-southeast2");
  const findRider = httpsCallable(functions, "websiteNewsletter");
  return findRider(data);
}
